<ng-container *ngrxLet="assistantStore.selectedDocumentState$ as documentsState">
  <div class="error-message" *ngIf="documentWithError">
    <app-banner [type]="'error'">
      {{ 'SERVICE_TICKET.DOWNLOAD_ERROR' | translate }}
    </app-banner>
  </div>
  <div *ngIf="!documentWithError" class="wrapper flex gap-[24px] flex-col">
    <div class="flex justify-between w-full items-start">
      <ng-container *ngIf="documentsState.searchDocument; else detailsTitle">
        <h2 class="header" title [innerHTML]="documentsState.searchDocument.title | stripHtml"></h2>
      </ng-container>
      <ng-template #detailsTitle>
        <h2
          class="header"
          *ngIf="documentsState.details.loaded"
          title
          [innerHTML]="documentsState.details.value.title | stripHtml"
        ></h2>
      </ng-template>
      <app-assistant-overlay-action-buttons
        *ngIf="displayActionButtons"
      ></app-assistant-overlay-action-buttons>
    </div>
    <div class="content-and-metadata flex flex-col gt-sm:flex-row gap-[24px]">
      <div class="flex-1 min-w-0">
        <ng-container *ngIf="!dataLoading; else loading">
          <ng-container
            [ngSwitch]="
              assistantHelperService.getDocumentType(
                documentsState.searchDocument || documentsState.details.value
              )
            "
          >
            <ng-container *ngSwitchCase="assistantDocumentType.pdf">
              <div class="pdf-preview-container flex flex-col">
                <app-pdf-preview
                  *ngIf="documentsState.content.loaded"
                  [src]="documentsState.content.value"
                  [originalSize]="false"
                  [showBorders]="true"
                  [zoom]="0"
                  [showAll]="false"
                  [autoresize]="true"
                  [allowNavigation]="true"
                  [allowZoomScale]="true"
                  [allowDownload]="true"
                  [documentTitle]="
                    documentsState.searchDocument
                      ? documentsState.searchDocument.title
                      : (documentsState.details.value.title | stripHtml)
                  "
                  gtmAction="Pdf document"
                  gtmCategory="assistantDocuments"
                  [page]="1"
                  (pageChanged)="onPageChanged()"
                >
                </app-pdf-preview>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="assistantDocumentType.html">
              <div
                *ngIf="!documentsState.images.loading; else loading"
                class="document-wrapper flex flex-col gap-[24px]"
                [innerHTML]="processedHtml | viassistAllowedHtml"
              ></div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #loading>
          <vi-loader data-at-loader [isLoading]="true"></vi-loader>
        </ng-template>
      </div>
      <div
        *ngIf="documentsState.searchDocument?.metadata?.length"
        class="metadata-panel flex flex-col gap-[12px]"
        data-at-assistant-metadata-panel
      >
        <h3 class="metadata-header">{{ '+ASSISTANT.DOCUMENT.METADATA.HEADER' | translate }}</h3>

        <div
          *ngFor="let item of documentsState.searchDocument?.metadata"
          class="metadata-item"
          [hidden]="!item.isVisible"
        >
          <span class="metadata-label">{{ item.attributeLabel }}</span>
          <span class="metadata-value">{{ item.label?.join(', ') }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
